var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.organization$.organization.id === 1)?_c('main-home'):(_vm.organization$.isMobius)?_c('mobius-home'):(_vm.organization$.isHanjin)?_c('hanjin-home'):_c('organization-home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }